import $ from "jquery";
import { endsWith } from "../typescript/Vgr.Util";

const allAction = document.querySelector('input[name="data-search-action-alla"]')?.value;
const webbAction = document.querySelector('input[name="data-search-action-webb"]')?.value;
const documentAction = document.querySelector('input[name="data-search-action-document"]')?.value;
const personAction = document.querySelector('input[name="data-search-action-person"]')?.value;
const organisationAction = document.querySelector('input[name="data-search-action-organisation"]')?.value;

const specialKeys = ["ArrowUp", "ArrowDown", "Escape", "Esc", "Tab"];
const isIntranet = document.body.getAttribute("data-internal") === "true";
const isInternalRequest = document.body.getAttribute("data-internal-request") === "true"

let urlRightPart = location.pathname;
const patternsToTrim = ["nu", "su", "sas", "skas", "narhalsan"];

const lang = document.documentElement.getAttribute('lang');

let showSearchSuggestions = true;

function getFrontendLogger() {
    return window.VgrFrontend && window.VgrFrontend.logger;
}

// Trim URL if it matches any pattern
patternsToTrim.forEach((pattern) => {
    if (endsWith(urlRightPart, pattern)) {
        urlRightPart = urlRightPart.substring(0, urlRightPart.lastIndexOf("/"));
    }
});

// Ensure the URL ends with a "/"
if (!endsWith(urlRightPart, "/")) {
    urlRightPart += "/";
}

const hsaid = getHsaIdUrlParam();
const searchScope = getScopeUrlParam() || (isIntranet ? "VGIntraProd" : "VGRegionvgregion");

let mouseClicked = false;

let hsaIdQuery = ""
let scopeQuery = "";
if (searchScope)
    scopeQuery = "&s=" + searchScope;
if (hsaid)
    hsaIdQuery = "&hsaids=" + hsaid;

function initializeAutocomplete(searchField, resultContainer, searchCategory, topDiv, bottomDiv, isGlobalSearch) {
    // This state machine handles a browser quirk:
    // focus events can fire in a different order when the user leaves/returns to the tab/window.
    // Goal: keep autocomplete state stable (open stays open, closed stays closed) across deactivation.

    // Skip one focusin-triggered fetch when focus is restored automatically by browser/window.
    let suppressNextFocusIn = false;

    // Debounce timer for keyup-triggered fetches to avoid too many requests while typing.
    let debounceTimer = null;
    const debounceDelay = 300;

    // Remember whether search field had focus when page visibility changed (tab switch/background tab).
    let searchFieldWasFocusedWhenHidden = false;

    // Remember whether search field had focus when browser window lost focus.
    let searchFieldWasFocusedWhenWindowBlurred = false;

    // If this page was opened in a background tab, suppress first automatic focusin behavior.
    let pageWasInitiallyHidden = document.visibilityState === "hidden";

    // True while browser/tab deactivation is happening; used to ignore close logic in focusout.
    let deactivationInProgress = false;

    // If autocomplete was open while leaving and focus was in search field, reopen on return if needed.
    let restoreOpenOnReturn = false;

    window.addEventListener("blur", () => {
        // Window lost focus (e.g. user clicked outside browser).
        // Capture current UI state before focusout handlers run.
        const searchFieldIsFocused = document.activeElement === searchField;
        const autocompleteIsOpen = !resultContainer.classList.contains("visually-hidden");

        deactivationInProgress = true;
        searchFieldWasFocusedWhenWindowBlurred = searchFieldIsFocused;
        restoreOpenOnReturn = restoreOpenOnReturn || (searchFieldIsFocused && autocompleteIsOpen);
    });

    window.addEventListener("focus", () => {
        // Window is active again: restore open state only when it was open at the time of deactivation.
        if (restoreOpenOnReturn && resultContainer.classList.contains("visually-hidden")) {
            toggleResultContainer(resultContainer, true);
            // Prevent an immediate extra fetch caused by auto-restored focus.
            suppressNextFocusIn = true;
        }

        if (searchFieldWasFocusedWhenWindowBlurred) {
            // Focus may return to searchField automatically; skip one focusin fetch.
            suppressNextFocusIn = true;
        }

        deactivationInProgress = false;
        restoreOpenOnReturn = false;
        searchFieldWasFocusedWhenWindowBlurred = false;
    });

    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
            // Tab/page became hidden.
            const searchFieldIsFocused = document.activeElement === searchField;
            const autocompleteIsOpen = !resultContainer.classList.contains("visually-hidden");

            deactivationInProgress = true;
            searchFieldWasFocusedWhenHidden = searchFieldIsFocused;
            restoreOpenOnReturn = restoreOpenOnReturn || (searchFieldIsFocused && autocompleteIsOpen);
            return;
        }

        if (document.visibilityState === "visible" && pageWasInitiallyHidden) {
            // Page opened in background tab and now shown for first time.
            // Keep current closed/open state and avoid auto-fetch on initial focus restoration.
            suppressNextFocusIn = true;
            pageWasInitiallyHidden = false;
            deactivationInProgress = false;
            restoreOpenOnReturn = false;
            searchFieldWasFocusedWhenHidden = false;
            return;
        }

        if (document.visibilityState === "visible" && restoreOpenOnReturn && resultContainer.classList.contains("visually-hidden")) {
            // Restore only if it was open when user left.
            toggleResultContainer(resultContainer, true);
            suppressNextFocusIn = true;
        }

        if (document.visibilityState === "visible" && searchFieldWasFocusedWhenHidden) {
            suppressNextFocusIn = true;
        }

        deactivationInProgress = false;
        restoreOpenOnReturn = false;
        searchFieldWasFocusedWhenHidden = false;
    });

    searchField.addEventListener("keyup", (event) => {
        if (specialKeys.includes(event.key)) {
            handleSpecialKeys(event, resultContainer, searchField);
        } else {
            suppressNextFocusIn = false;
            // Debounce: cancel any pending fetch and wait for the user to pause typing.
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                fetchAutocompleteSuggestions(searchField, resultContainer, topDiv, bottomDiv, isGlobalSearch, searchCategory);
            }, debounceDelay);
        }
    });

    searchField.addEventListener("focusin", (event) => {
        // Ignore one synthetic/auto focus restoration event after returning to tab/window.
        if (suppressNextFocusIn) {
            suppressNextFocusIn = false;
            return;
        }

        if (resultContainer.classList.contains("visually-hidden")) {
            fetchAutocompleteSuggestions(searchField, resultContainer, topDiv, bottomDiv, isGlobalSearch, searchCategory);
        }
    });

    searchField.addEventListener("focusout", (event) => {
        // During deactivation, never close autocomplete from focusout.
        // This preserves state when returning to tab/window.
        if (deactivationInProgress || document.visibilityState === "hidden") {
            mouseClicked = false;
            return;
        }

        suppressNextFocusIn = false;

        if (!mouseClicked) {
            const relatedTarget = event.relatedTarget;

            if (relatedTarget == null) {
                // If relatedTarget is null, browser may be in the middle of deactivation.
                // Defer close and only close when document still has focus.
                setTimeout(() => {
                    if (!document.hasFocus()) {
                        return;
                    }

                    if ($(document.activeElement).parents('#' + resultContainer.id).length < 1 && document.activeElement !== searchField) {
                        toggleResultContainer(resultContainer, false);
                    }
                }, 0);
            }
            else if ($(relatedTarget).parents('#' + resultContainer.id).length < 1) {
                toggleResultContainer(resultContainer, false);
            }
        }
        //återställ flaggan - se mousedown eventet nedan
        mouseClicked = false;
    });

    //Klick i resultContainer stänger den pga focusout-eventet utan nedanstående.
    //'mousedown'-eventet triggas före focusout
    document.addEventListener("mousedown", (event) => {
        mouseClicked = true;
    });

    document.addEventListener("click", (event) => {
        const target = event.target;
        if (target === searchField) {
            if (resultContainer.classList.contains("visually-hidden")) {
                suppressNextFocusIn = false;
                fetchAutocompleteSuggestions(searchField, resultContainer, topDiv, bottomDiv, isGlobalSearch, searchCategory);
            }
        }
        else if ($(target).parents('#' + resultContainer.id).length < 1) {
            toggleResultContainer(resultContainer, false);
        }
        mouseClicked = false;
    });
}

function handleSpecialKeys(event, resultContainer, searchField) {
    const links = resultContainer.querySelectorAll("a");
    links.forEach((link) => {
        link.addEventListener("keydown", (e) => handleKeyDown(e, resultContainer, searchField));
    });
    handleKeyDown(event, resultContainer, searchField);
}

function fetchAutocompleteSuggestions(searchField, resultContainer, topDiv, bottomDiv, isGlobalSearch, searchCategory) {
    const query = searchField.value.trim() || "*";
    const fetchUrl = '/api/querycompletions/websearch/';

    if (searchCategory === "webb" || searchCategory === 'sidor')
        searchCategory = "www";
    else if (searchCategory === "verksamheter")
        searchCategory = "verksamhet";
    else if (searchCategory === 'personer')
        searchCategory = "person";

    const requestUrl = `${fetchUrl}?q=${query}&s=${searchScope}&hsaids=${hsaid}&category=${searchCategory}&lang=${lang}`;

    fetch(requestUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) => {
            if (!response.ok) {
                const error = new Error(`Request failed with status ${response.status}`);
                error.status = response.status;
                throw error;
            }

            return response.json();
        })
        .then((data) => {
            showSearchResults(query, data, resultContainer, topDiv, bottomDiv, isGlobalSearch, searchCategory);
        })
        .catch((error) => {
            const frontendLogger = getFrontendLogger();
            if (frontendLogger && typeof frontendLogger.logError === "function") {
                frontendLogger.logError({
                    category: "autocomplete",
                    eventName: "querycompletion-request-failed",
                    componentOrWidget: "AutocompleteSearch",
                    url: requestUrl,
                    data: {
                        status: error && error.status,
                        name: error && error.name,
                        message: error && error.message,
                    },
                });
            }
            console.error("Autocomplete fetch error:", error)
        })
}

function handleKeyDown(event, resultContainer, searchField) {

    let linkItems = Array.from(resultContainer.querySelectorAll("a"));

    switch (event.key) {
        case 'ArrowDown':
        case 'Down':
            {
                event.preventDefault();
                const nextIndex = linkItems.indexOf(event.target) + 1;
                linkItems[nextIndex === linkItems.length ? 0 : nextIndex]?.focus();

                if (nextIndex === linkItems.length) {
                    setTimeout(function () {
                        const y = searchField.getBoundingClientRect().top + window.scrollY;
                        window.scroll({
                            top: y,
                            behavior: 'smooth'
                        });
                    }, 100)
                }
            }
            break;
        case 'ArrowUp':
        case 'Up':
            {
                event.preventDefault();
                const nextIndex = linkItems.indexOf(event.target) - 1;
                if (nextIndex === -1) {
                    searchField.focus();
                }
                else {
                    linkItems[nextIndex]?.focus();
                }
            }
            break;
        case 'Tab':
            {
                if (event.shiftKey) {
                    const nextIndex = linkItems.indexOf(event.target) - 1;
                    if (nextIndex < 0) {
                        event.preventDefault();
                        searchField.focus();
                    }
                }
                else {
                    const nextIndex = linkItems.indexOf(event.target) + 1;
                    if (nextIndex === linkItems.length) {
                        let focusable = $(':focusable');
                        let searchFieldIndex = focusable.index($(searchField));
                        focusable.eq(searchFieldIndex).trigger('focus');
                    }
                }
            }
            break;
        case 'Escape':
        case 'Esc':
            {
                searchField.focus();
                toggleResultContainer(resultContainer, false);
            }
            break;
    }
}

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0].toLowerCase() === sParam.toLowerCase()) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

function getScopeUrlParam() {
    let scope = getUrlParameter("scope");
    const hiddenValue = document.querySelector('input[name="s"]').value;
    if (!scope)
        scope = getUrlParameter("s");

    if (scope == '' || scope == undefined)
        scope = hiddenValue;

    if (!scope) {
        scope = '';
    }
    return scope;
}

function getHsaIdUrlParam() {
    let hsaId = getUrlParameter("hsaids");
    const hiddenValue = document.querySelector('input[name="HsaIdCollection"]').value;
    if (!hsaId) {
        hsaId = getUrlParameter("HsaIdCollection");
    }
    if (hsaId == '' || hsaId == undefined)
        hsaId = hiddenValue;

    if (!hsaId)
        hsaId = "";
    return hsaId;
}

function showSearchResults(query, data, resultContainer, topDiv, bottomDiv, isGlobalSearch, searchCategory) {
    topDiv.innerHTML = "";
    bottomDiv.innerHTML = "";

    const sections = document.querySelectorAll('.autocomplete__section');
    sections.forEach(function (section) {
        section.remove();
    });

    const scope = getScopeUrlParam() || "VGIntraProd";
    
    if (query === "" || query === undefined)
        query = "*";

    const gridClasses = isGlobalSearch ? 'g-col-sm-12 ' : 'g-col-md-6 g-col-sm-12 ';

    const suggestions = data?.length === 0 ? [] : JSON.parse(data).suggestions;

    const searchQueries = suggestions.filter((n) => n.category === "search_query");
    const www = searchCategory === 'alla' || searchCategory === 'www' ? suggestions.filter((n) => n.category === "www") : [];
    const dokument = searchCategory === 'alla' || searchCategory === 'dokument' ? suggestions.filter((n) => n.category === "dokument") : [];
    const verksamhet = searchCategory === 'alla' || searchCategory === 'verksamhet' ? suggestions.filter((n) => n.category === "verksamhet") : [];
    const person = searchCategory === 'alla' || searchCategory === 'person' ? suggestions.filter((n) => n.category === "person") : [];

    const isMobile = window.innerWidth < 768;
    const noOfHits = isGlobalSearch || isMobile ? 2 : searchCategory === 'alla' ? 3 : 5;
    showSearchSuggestions = isGlobalSearch || searchCategory === 'alla';

    const hasNoSearchHits = www.length === 0 && dokument.length === 0 && verksamhet.length === 0 && person.length === 0;

    if ((suggestions === null || suggestions.length === 0) ||
        (showSearchSuggestions && searchQueries.length === 0 && hasNoSearchHits) ||
        (!showSearchSuggestions && hasNoSearchHits)) {
        toggleResultContainer(resultContainer, false);
        return;
    }

    const elements = [
        { func: addSearchQueries, data: searchQueries, parent: topDiv, queryText: query, cssClass: gridClasses, hasHits: (searchQueries?.length ?? 0) > 0, isGlobalSearch: isGlobalSearch },
        { func: addWww, data: www, parent: bottomDiv, queryText: query, cssClass: gridClasses, nummerhits: noOfHits, hasHits: (www?.length ?? 0) > 0, scope },
        { func: addVerksamhet, data: verksamhet, parent: bottomDiv, queryText: query, cssClass: gridClasses, nummerhits: noOfHits, hasHits: (verksamhet?.length ?? 0) > 0, scope },
        { func: addDokument, data: dokument, parent: bottomDiv, queryText: query, cssClass: gridClasses, nummerhits: noOfHits, hasHits: (dokument?.length ?? 0) > 0, scope }
    ];

    if (isInternalRequest) {
        elements.push({ func: addPerson, data: person, parent: bottomDiv, queryText: query, cssClass: gridClasses, nummerhits: noOfHits, hasHits: (person?.length ?? 0) > 0, scope })
    }

    // Sortera så att kategorier med träffar kommer först
    elements.sort((a, b) => Number(b.hasHits) - Number(a.hasHits));

    // Kör funktionerna för att lägga till resultat
    elements.forEach(item => {
        if (item.hasHits) { // Endast om det finns träffar för en kategori
            item.func(item.data, item.parent, item.queryText, item.cssClass, item.nummerhits);
        }
    });

    // Skapa box med länkar till Alla sidor, etc.. om någon av söktyperna saknar träffar från querycompletion
    if (searchCategory === 'alla' && hasSearchTypeWithNoHits(www, dokument, verksamhet, person, isInternalRequest)) {
        let linksBubble = document.createElement('section');
        linksBubble.className = gridClasses + 'autocomplete-resultheader autocomplete__section';
        bottomDiv.appendChild(linksBubble);

        let newWebbHref = webbAction + "?q=*" + (scopeQuery + hsaIdQuery);
        let newDokumentHref = documentAction + "?q=*" + (scopeQuery + hsaIdQuery);
        let newVerksamhetHref = organisationAction + "?q=*" + (scopeQuery + hsaIdQuery);
        let newPersonHref = personAction + ("?q=*") + (scopeQuery + hsaIdQuery);

        // Skapa en lista med länkar
        let ul = document.createElement('ul');
        ul.className = 'autocomplete__list';
        linksBubble.appendChild(ul);

        // Länkar
        let links = [];
        if (webbAction) {
            links.push({ text: lang === "en" ? "All pages" : "Alla sidor", href: newWebbHref, className: 'autocomplete__item--web', data: www });
        }
        if (organisationAction) {
            links.push({ text: lang === "en" ? "All organizations" : "Alla verksamheter", icon: "🏢", href: newVerksamhetHref, className: 'autocomplete__item--organisation', data: verksamhet });
        }
        if (documentAction) {
            links.push({ text: lang === "en" ? "All documents" : "Alla dokument", icon: "📄", href: newDokumentHref, className: 'autocomplete__item--pdf', data: dokument });
        }
        if (isInternalRequest && personAction) {
            links.push({ text: lang === "en" ? "All persons" : "Alla personer", icon: "👤", href: newPersonHref, className: 'autocomplete__item--person', data: person });
        }

        // Skapa <li> för varje länk
        links.forEach(function (link) {
            if (link.data.length === 0) {
                let li = document.createElement('li');

                li.classList.add('autocomplete__item', 'autocomplete__item--image', 'autocomplete__no-result-item');
                li.classList.add(link.className);


                ul.appendChild(li);
                let a = document.createElement('a');
                a.className = 'autocomplete__moreinfo';
                a.href = link.href;

                a.innerHTML = link.text;
                li.appendChild(a);
            }
        });
    }
    if (searchCategory !== 'alla') {
        bottomDiv.classList.add('autocomplete-result__bottom-section--single');
    }
    if(hasNoSearchHits) {
        document.getElementsByClassName('autocomplete-resultheader')[0].classList.add('autocomplete-resultheader--br');
    }
    toggleResultContainer(resultContainer, true);
}

function hasSearchTypeWithNoHits(www, dokument, verksamhet, person, isInternalRequest) {
    if (isInternalRequest)
        return www.length === 0 || dokument.length === 0 || verksamhet.length === 0 || person.length === 0;
    return www.length === 0 || dokument.length === 0 || verksamhet.length === 0;
}

function addSearchQueries(queries, container, isGlobalSearch) {
    if(!showSearchSuggestions) return;
    
    let linkUrl = window.location.pathname;
    if (isGlobalSearch) {
        linkUrl = allAction ? allAction : webbAction;
    }
    linkUrl += "?qc=true&q=";

    container = document.querySelector("#" + container.id);

    if (container != undefined && container.children != undefined && container.children.length > 0) {
        return;
    }

    let headertext = lang === "en" ? "Search suggestions" : "Sökordsförslag";

    let header = $("<section>", { html: `<h2 class="autocomplete__header autocomplete__header-suggestions">${headertext}</h2>` }).appendTo(container);

    header.addClass("autocomplete-resultheader");
    let ulList = $(header).append("<ul id='searchquery-list' class='autocomplete__list' ></ul>").find("#searchquery-list");

    if (queries.length < 1) return;
    $.each(queries, function (i) {
        let format = ('autocomplete__item autocomplete__item--search ' + (queries[i].format != null && queries[i].format != undefined ? "file " + queries[i].format.substring(queries[i].format.lastIndexOf(".") + 1) : "autocomplete__item autocomplete__item--search file"));
        let li = $("<li/>").appendTo(ulList);
        li.addClass(format);
        let aaa = $("<a>", {
            html: queries[i].label_hl,
            href: linkUrl + queries[i].label + scopeQuery + hsaIdQuery
        }).appendTo(li);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom sökordsförslag");
        if (queries[i].revisiondate != null || queries[i].scopelabel != null) {
            $("<p>", {
                html: (queries[i].revisiondate != null ? queries[i].revisiondate : "") + (queries[i].scopelabel != null ? " - " + queries[i].scopelabel : ""),
                class: 'autocomplete__description'
            }).appendTo(li);
        }
    });
}

function addWww(queries, container, queryText, cssClass, nummerhits, scope = "") {
    if (!webbAction) return;
    container = document.querySelector("#" + container.id);
    if (container != undefined && container.children != undefined && container.children.length > 3)
        return;
    let headerText = lang === "en" ? "Pages" : "Sidor";
    let header = $("<section>", { html: `<h2 class="autocomplete__header autocomplete__header--dark">${headerText}</h2>` }).appendTo(container);

    let section = header.addClass(cssClass + "autocomplete-resultheader autocomplete__section");
    let ulList = $(header).append("<ul id='www-list' class='autocomplete__list' ></ul>").find("#www-list");

    if (queries.length < 1) return;

    if (scope) {
        scopeQuery = "&s=" + scope;
    }

    $.each(queries, function (i) {
        if (i >= nummerhits)
            return;
        let li = $("<li/>").appendTo(ulList);
        li.addClass("autocomplete__item autocomplete__item--image autocomplete__item--web image web");
        let div = $("<div>", {
            class: "autocomplete__content-wrapper"
        }).appendTo(li);
        let aaa = $("<a>", {
            html: queries[i].label_hl ?? queries[i].label,
            href: queries[i].url
        }).appendTo(div);

        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom Webb");
        if (queries[i].revisiondate != null || queries[i].scopelabel != null) {
            $("<p>", {
                html: (queries[i].revisiondate != null ? queries[i].revisiondate : "") + (queries[i].scopelabel != null ? " - " + queries[i].scopelabel : ""),
                class: 'autocomplete__description'
            }).appendTo(div);
        }
    });

    let action = webbAction + "?q=" + queryText + scopeQuery + hsaIdQuery;
    if (action.endsWith('/')) {
        action = action.slice(0, -1); // Ta bort sista tecknet (slash)
    }
    let a = $("<a>", {
        href: action
    }).append(lang === "en" ? "Show more pages" : "Visa fler sidor");
    a.addClass("autocomplete__moreinfo")
    a.appendTo(section);
}

function addDokument(queries, container, queryText, cssClass, nummerhits, scope = "") {
    if(!documentAction) return;
    container = document.querySelector("#" + container.id);
    if (container != undefined && container.children != undefined && container.children.length > 3)
        return;

    let headertext = lang === "en" ? "Documents" : "Dokument";
    let header = $("<section>", { html: `<h2 class="autocomplete__header autocomplete__header--dark">${headertext}</h2>` }).appendTo(container);

    let section = header.addClass(cssClass + "autocomplete-resultheader autocomplete__section dokument");
    let ulList = $(header).append("<ul id='dokument-list' class='autocomplete__list'></ul>").find("#dokument-list");

    if (queries.length < 1) return;

    if (scope) {
        scopeQuery = "&s=" + scope;
    }

    $.each(queries, function (i) {
        if (i >= nummerhits)
            return;
        let classname = ' autocomplete__item autocomplete__item--file autocomplete__item--pdf';
        let format = (queries[i].format != null && queries[i].format != undefined ? "file " + queries[i].format.substring(queries[i].format.lastIndexOf(".") + 1) : "file");

        let li = $("<li/>").appendTo(ulList);
        li.addClass(format + classname);

        let div = $("<div>", {
            class: "autocomplete__content-wrapper"
        }).appendTo(li);
        let aaa = $("<a>", {
            html: queries[i].label_hl ?? queries[i].label,
            href: queries[i].url
        }).appendTo(div);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom dokument");
        if (queries[i].revisiondate != null || queries[i].scopelabel != null) {
            $("<p>", {
                html: (queries[i].revisiondate != null ? queries[i].revisiondate : "") + (queries[i].scopelabel != null ? " • " + queries[i].scopelabel : ""),
                class: 'autocomplete__description'
            }).appendTo(div);
        }
    });

    let newHref = documentAction + "?q=" + queryText + scopeQuery + hsaIdQuery;

    if (newHref.endsWith('/')) {
        newHref = newHref.slice(0, -1); // Ta bort sista tecknet (slash)
    }
    let a = $("<a>", {
        html: lang === "en" ? "Show more documents" : "Visa fler dokument",
        href: newHref // Använd den uppdaterade URL:en
    });

    a.addClass("autocomplete__moreinfo").appendTo(section);
}

function addVerksamhet(queries, container, queryText, cssClass, nummerhits, scope = "") {
    if(!organisationAction) return;
    container = document.querySelector("#" + container.id);
    if (container != undefined && container.children != undefined && container.children.length > 3)
        return;

    let headertext = lang === "en" ? "Organizations" : "Verksamheter";
    let header = $("<section>", { html: `<h2 class="autocomplete__header autocomplete__header--dark">${headertext}</h2>` }).appendTo(container);

    let section = header.addClass(cssClass + "autocomplete-resultheader autocomplete__section verksamhet");
    let ulList = $(header).append("<ul id='verksamhet-list' class='autocomplete__list'></ul>").find("#verksamhet-list");


    if (queries.length < 1) return;

    if (scope) {
        scopeQuery = "&s=" + scope;
    }

    $.each(queries, function (i) {
        if (i >= nummerhits)
            return;
        let li = $("<li/>").appendTo(ulList);
        li.addClass("autocomplete__item autocomplete__item--image autocomplete__item--organisation image business");

        let href = '';
        if (queries[i].hsaIdentity !== undefined) {
            href = organisationAction + '?hsaIdentity=' + queries[i].hsaIdentity + scopeQuery + hsaIdQuery;
        } else {
            href = organisationAction + queries[i].hsaIdentity;
        }
        let div = $("<div>", {
            class: "autocomplete__content-wrapper"
        }).appendTo(li);
        let aaa = $("<a>", {
            html: queries[i].label_hl ?? queries[i].label,
            href: href
        }).appendTo(div);
        aaa.attr('aria-label', queries[i].label + " inom verksamheter");
        aaa.addClass("autocomplete__link");
        if (queries[i].phonenumber != null) {
            $("<p>", {
                class: "autocomplete__description",
                html: queries[i].phonenumber
            }).appendTo(div);
        }

    });

    let newHref = organisationAction + "?q=" + queryText + scopeQuery + hsaIdQuery;

    if (newHref.endsWith('/')) {
        newHref = newHref.slice(0, -1); // Ta bort sista tecknet (slash)
    }
    let a = $("<a>", {
        html: lang === "en" ? "Show more organizations" : "Visa fler verksamheter",
        href: newHref // Använd den uppdaterade URL:en
    });

    a.addClass("autocomplete__moreinfo").appendTo(section);
}

function addPerson(queries, container, queryText, cssClass, nummerhits, scope = "") {
    if(!personAction) return;
    container = document.querySelector("#" + container.id);
    if (container != undefined && container.children != undefined && container.children.length > 3)
        return;

    let headertext = lang === "en" ? "Persons" : "Personer";
    let header = $("<section>", { html: `<h2 class="autocomplete__header autocomplete__header--dark">${headertext}</h2>` }).appendTo(container);

    let section = header.addClass(cssClass + "autocomplete-resultheader autocomplete__section person");
    let ulList = $(header).append("<ul id='person-list' class='autocomplete__list' ></ul>").find("#person-list");

    if (queries.length < 1) return;

    if (scope) {
        scopeQuery = "&s=" + scope;
    }

    $.each(queries, function (i) {
        if (i >= nummerhits)
            return;
        let li = $("<li/>").appendTo(ulList);

        li.addClass("autocomplete__item autocomplete__item--image autocomplete__item--person image person");

        let href = '';
        if (queries[i].vgrid !== undefined) {
            href = personAction + '?vgrid=' + queries[i].vgrid + scopeQuery + hsaIdQuery;
        } else {
            href = personAction + '?vgrid=' + queries[i].vgrid;
        }
        let div = $("<div>", {
            class: "autocomplete__content-wrapper"
        }).appendTo(li);
        let aaa = $("<a>", {
            html: queries[i].label_hl ?? queries[i].label,
            href: href,
        }).appendTo(div);
        aaa.addClass("autocomplete__link");
        aaa.attr('aria-label', queries[i].label + " inom person");
        if (queries[i].email != null) {
            $("<p>", {
                class: "autocomplete__description",
                html: queries[i].email
            }).appendTo(div);
        }
    });

    let newHref = personAction + "?q=" + queryText + scopeQuery + hsaIdQuery;

    if (newHref.endsWith('/')) {
        newHref = newHref.slice(0, -1); // Ta bort sista tecknet (slash)
    }
    let a = $("<a>", {
        html: lang === "en" ? "Show more persons" : "Visa fler personer",
        href: newHref // Använd den uppdaterade URL:en
    });

    a.addClass("autocomplete__moreinfo").appendTo(section);
}

function toggleResultContainer(resultContainer, open) {
    if (open) {
        resultContainer.classList.remove("hidden", "visually-hidden");
        resultContainer.setAttribute("aria-hidden", "false");
        resultContainer.querySelectorAll("a").forEach(el => el.setAttribute("tabindex", "0"));
    }
    else {
        $(resultContainer).addClass("hidden");
        resultContainer.classList.add("visually-hidden");
        resultContainer.setAttribute("aria-hidden", "true"); // För skärmläsare
        resultContainer.querySelectorAll("a").forEach(el => el.setAttribute("tabindex", "-1"));
    }
}

export { initializeAutocomplete };
